"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ButtonRadioOption_1 = __importDefault(require("./ButtonRadioOption"));

var styled_1 = require("./styled");

var ButtonRadio =
/** @class */
function (_super) {
  __extends(ButtonRadio, _super);

  function ButtonRadio(props) {
    var _this = _super.call(this, props) || this;

    _this.selectButton = function (option) {
      var onChange = _this.props.onChange;

      _this.setState({
        value: option.value
      });

      onChange(option);
    };

    _this.getValues = function () {
      var _a;

      var id = _this.props.id;
      var value = _this.state.value;

      if (id) {
        return _a = {}, _a[id] = value, _a;
      }

      return {};
    };

    _this.state = {
      value: props.defaultValue
    };
    return _this;
  }

  ButtonRadio.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        orientation = _a.orientation,
        options = _a.options;
    var value = this.props.value !== undefined ? this.props.value : this.state.value;
    return react_1.default.createElement(styled_1.ButtonRadioWrapper, {
      orientation: orientation
    }, options.map(function (opt) {
      return react_1.default.createElement(ButtonRadioOption_1.default, {
        isActive: opt.value === value,
        key: opt.value,
        option: opt,
        onClick: _this.selectButton,
        orientation: orientation
      });
    }));
  };

  ButtonRadio.defaultProps = {
    orientation: 'horizontal',
    onChange: function onChange() {
      return {};
    }
  };
  return ButtonRadio;
}(react_1.PureComponent);

exports.ButtonRadio = ButtonRadio;
exports.default = ButtonRadio;